import { formatMoney } from '@theme/money-formatting';

(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var DEK = document.createElement('textarea');
  function attr(el, name) { DEK.innerHTML = el.getAttribute(name) || ''; return DEK.value; }
  var HAKEN = '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var WURZEL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function auswahl() {
    try { return JSON.parse(localStorage.getItem('3idee_auswahl') || 'null') || {}; } catch (e) { return {}; }
  }
  function engineLage() {
    var a = auswahl();
    var wand = a.mount === 'wall';
    var dicke = (!wand && a.tisch && Number(a.tisch.dicke_cm)) ? Math.round(Number(a.tisch.dicke_cm) * 10) : 0;
    return { wand: wand, dicke: dicke, art: (!wand && a.tisch && a.tisch.art) || '' };
  }

  function auswahlRefs() {
    try {
      var roh = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null');
      return (roh && roh.refs && roh.refs.length) ? roh.refs.map(String) : [];
    } catch (e) { return []; }
  }

  function adapterDaten(block) {
    if (block.__vlAdapter === undefined) {
      var el = block.querySelector('script[data-vl-adapter]');
      try { block.__vlAdapter = el ? JSON.parse(el.textContent) : null; } catch (e) { block.__vlAdapter = null; }
    }
    return block.__vlAdapter || { modelle: [], varianten: [] };
  }

  function abruf(url) {
    if (window.EngineStatus) return window.EngineStatus.hol(url);
    return fetch(url).then(function (r) { return r.json(); });
  }

  var engineCache = {};
  function proxyVon(block) {
    return (window.FinderClean && window.FinderClean.proxy) || block.getAttribute('data-vl-proxy') || '/apps/monitor-db';
  }
  function engine(block, refs) {
    refs = [].concat(refs);
    var arme = refs.length;
    var el = engineLage();
    var schluessel = refs.join(',') + '|' + el.wand + '|' + el.dicke;
    if (engineCache[schluessel]) return engineCache[schluessel];
    var qs = refs.map(function (r) { return 'm=' + encodeURIComponent(r); }).join('&');
    if (!el.wand) qs += '&mount_type=tischhalterung';
    if (el.dicke) qs += '&table_thickness_mm=' + el.dicke;
    engineCache[schluessel] = abruf(proxyVon(block) + '/combinations/compatible?' + qs)
      .then(function (j) {
        var combos = (j && j.ok && j.data && j.data.combinations) || [];
        var raus = { kg: 0, liste: [] }, gesehen = {};
        combos.forEach(function (c) {
          var p = c.product;
          if (!p || !p.handle || p.in_shop === false) return;
          if (c.status && c.status !== 'visible') return;
          if (Number(c.monitors) && Number(c.monitors) !== arme) return;
          if (el.wand && String(c.mount_type || '').indexOf('wand') !== 0) return;
          if (c.setup_weight_kg != null && c.weight_kg != null) {
            raus.kg = Math.max(raus.kg, Number(c.setup_weight_kg) - Number(c.weight_kg));
          }
          if (gesehen[p.handle]) {
            if (c.empfehlung && !gesehen[p.handle].empfehlung) gesehen[p.handle].empfehlung = c.empfehlung;
            return;
          }
          var platte = (c.fit === 'bundle' && c.requires && c.requires[0]) ? c.requires[0] : null;
          gesehen[p.handle] = {
            handle: p.handle, empfehlung: c.empfehlung || null, kind: c.kind || '',
            sku: p.shopify_sku || c.sku || '',
            platteSku: (platte && platte.sku) || '', platteStueck: (platte && Number(platte.qty)) || 1,
            setupKg: c.setup_weight_kg != null ? Number(c.setup_weight_kg) : null
          };
          raus.liste.push(gesehen[p.handle]);
        });
        return raus;
      })
      .catch(function () { delete engineCache[schluessel]; return null; });
    return engineCache[schluessel];
  }

  var produktCache = {};
  function produkt(handle) {
    if (produktCache[handle]) return produktCache[handle];
    produktCache[handle] = fetch(WURZEL + 'products/' + handle + '?section_id=mini-produktseite')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var raum = document.createElement('div');
        raum.innerHTML = html;
        var roh = raum.querySelector('[data-mpd-daten]');
        return roh ? JSON.parse(roh.textContent) : null;
      })
      .catch(function () { delete produktCache[handle]; return null; });
    return produktCache[handle];
  }

  function monitorListe(block) {
    if ((block.__vlMonitore || []).length) {
      return block.__vlMonitore.filter(function (m) { return m && m.ref != null; }).map(function (m) {
        return { ref: String(m.ref), name: m.name || '', stufe: m.stufe || '', anzahl: Number(m.anzahl) || 1, alt: (m.alternativen || [])[0] || '' };
      });
    }
    var zahl = {}, folge = [];
    auswahlRefs().forEach(function (r) { if (!zahl[r]) { zahl[r] = 0; folge.push(r); } zahl[r]++; });
    return folge.map(function (r) { return { ref: r, name: '', stufe: '', anzahl: zahl[r], alt: '' }; });
  }

  function lage(block) {
    var modelle = (adapterDaten(block).modelle || []).map(function (m) { return String(m.ref); });
    var ms = monitorListe(block);
    var refs = [], eigen = 0, fremd = [];
    ms.forEach(function (m) {
      var hier = modelle.indexOf(m.ref) > -1 || m.stufe === 'ok';
      if (m.stufe === 'warn' && !m.alt) return;
      if (!m.stufe && !hier) return;
      if (m.stufe === 'warn') fremd.push(m);
      else if (hier) eigen += m.anzahl;
      for (var i = 0; i < m.anzahl; i++) refs.push(m.ref);
    });
    var kennung = ms.map(function (m) { return m.ref + ':' + m.stufe + ':' + m.anzahl + ':' + m.alt; }).join(',');
    if (eigen || fremd.length) {
      return { refs: refs, geprueft: true, n: refs.length, eigen: eigen, fremd: fremd, kennung: kennung };
    }
    var gewaehlt = auswahlRefs();
    if (!modelle.length && gewaehlt.length && block.__vlPassung === 'ok') {
      return { refs: gewaehlt, geprueft: true, n: gewaehlt.length, eigen: gewaehlt.length, fremd: [], kennung: kennung };
    }
    return { refs: unique(modelle), geprueft: false, n: 1, eigen: 1, fremd: [], kennung: kennung, einzeln: true };
  }
  function unique(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }

  function zeilenWaehlen(block, antworten, n) {
    antworten = antworten.filter(Boolean);
    if (!antworten.length) return null;
    var massgeblich = antworten.reduce(function (a, b) { return b.kg > a.kg ? b : a; });
    var ueberall = function (h) {
      return antworten.every(function (a) { return a.liste.some(function (e) { return e.handle === h; }); });
    };
    var zeilen = [];
    ['spar', 'zweiter'].forEach(function (art) {
      var e = massgeblich.liste.filter(function (x) { return x.empfehlung === art && x.kind !== 'one'; })[0];
      if (e && ueberall(e.handle) && zeilen.indexOf(e.handle) < 0) zeilen.push(e.handle);
    });
    if (!zeilen.length && engineLage().wand) {
      massgeblich.liste.forEach(function (x) {
        if (zeilen.length < 2 && x.kind !== 'one' && ueberall(x.handle)) zeilen.push(x.handle);
      });
    }
    var oneOptionen = massgeblich.liste.filter(function (x) { return x.kind === 'one' && ueberall(x.handle); })
      .map(function (x) { return x.handle; });
    var eintraege = {};
    massgeblich.liste.forEach(function (x) { eintraege[x.handle] = x; });
    return { zeilen: zeilen, oneOptionen: oneOptionen, eintraege: eintraege };
  }

  function verstaerkung() {
    if (window.Verstaerkung) return Promise.resolve(window.Verstaerkung);
    if (document.readyState === 'complete') return Promise.resolve(null);
    return new Promise(function (fertig) {
      var los = function () { fertig(window.Verstaerkung || null); };
      document.addEventListener('DOMContentLoaded', los, { once: true });
      setTimeout(los, 4000);
    });
  }

  function bolzen(block) {
    var RANG = { REQUIRED: 3, RECOMMENDED: 2, OPTIONAL: 1 };
    var beste = null, stueck = 0;
    (block.__vlMonitore || []).forEach(function (m) {
      if (!m || m.stufe === 'rec') return;
      var e = ((m.zubehoer || [])[0]) || null;
      if (!e || !e.handle) return;
      stueck += Number(m.anzahl) || 1;
      if (!beste || (RANG[e.stufe] || 0) > (RANG[beste.stufe] || 0)) beste = e;
    });
    return (beste && beste.stufe === 'REQUIRED' && beste.imShop !== false) ? { u: beste, stueck: stueck || 1 } : null;
  }
  function bolzenKennung(block) {
    var b = bolzen(block);
    return b ? b.u.handle + 'x' + b.stueck : '';
  }

  function teilName(d, u) {
    return String((d && (d.serie || d.titel)) || (u && u.name) || '').split('|')[0].split(' · ')[0].trim();
  }

  function pflichtteile(block, e) {
    if (!e) return Promise.resolve([]);
    var el = engineLage();
    var eigen = String(block.getAttribute('data-vl-seite') || '');
    var b = bolzen(block);
    var urteile = verstaerkung().then(function (V) {
      if (!V || !(el.art || e.setupKg || e.platteSku)) return {};
      return V.pruefe({ proxy: proxyVon(block), art: el.art, kg: e.setupKg, mountSku: e.sku, plateSku: e.platteSku });
    }).catch(function () { return {}; });
    return urteile.then(function (p) {
      p = p || {};
      var liste = [];
      var tisch = p.TABLE_REINFORCEMENT, platte = p.PLATE;
      if (tisch && tisch.handle && tisch.imShop !== false && tisch.stufe === 'REQUIRED') liste.push({ u: tisch, stueck: 1 });
      if (platte && platte.handle && platte.imShop !== false && platte.handle !== eigen
          && (platte.stufe === 'REQUIRED' || platte.stufe === 'RECOMMENDED')) liste.push({ u: platte, stueck: e.platteStueck || 1 });
      if (b) liste.push(b);
      return Promise.all(liste.map(function (x) {
        return produkt(x.u.handle).then(function (d) {
          var v = d && (d.varianten || []).filter(function (y) { return y.kaufbar; })[0];
          return v ? { id: v.id, betrag: v.betrag, stueck: x.stueck, name: teilName(d, x.u) } : null;
        });
      })).then(function (a) { return a.filter(Boolean); });
    });
  }

  function stufeCent(block, d, betrag) {
    var stufe = d && d.stufe;
    if (stufe === 'one') return (Number(block.getAttribute('data-vl-bundle-one')) || 0) * 100;
    if (stufe === 'flexi') {
      var ab = Number(block.getAttribute('data-vl-bundle-flexi-ab')) || 0;
      if (ab > 0 && betrag >= ab * 100) return (Number(block.getAttribute('data-vl-bundle-flexi-hoch')) || 0) * 100;
      return (Number(block.getAttribute('data-vl-bundle-flexi')) || 0) * 100;
    }
    return 0;
  }

  function geld(block, cent) {
    try { return formatMoney(cent, block.getAttribute('data-vl-format') || '', block.getAttribute('data-vl-waehrung') || ''); }
    catch (e) { return (cent / 100).toFixed(2); }
  }

  function serieVon(d) {
    var s = (d && d.serie) || '';
    if (s) return s;
    return String((d && d.titel) || '').split(' · ')[0];
  }

  function gruendeVon(block, d, istOne) {
    if (istOne) {
      return (attr(block, 'data-vl-one-gruende') || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    var s = serieVon(d).toLowerCase().replace(/[^a-z]/g, '');
    var t = '';
    if (s.indexOf('flexilite') > -1) t = attr(block, 'data-vl-grund-flexilite');
    else if (s.indexOf('flexipro') > -1) t = attr(block, 'data-vl-grund-flexipro');
    else if (s.indexOf('montek') > -1) t = attr(block, 'data-vl-grund-montek');
    return t.split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function rechnung(block, d) {
    var v = (d.varianten || []).filter(function (x) { return x.kaufbar; })[0];
    if (!v) return null;
    var l = block.__vlLage || { n: 1, eigen: 1, fremd: [] };
    var n = l.n || 1;
    var adapter = (l.eigen || 0) + (l.fremd || []).reduce(function (s, m) { return s + m.anzahl; }, 0);
    var vorteil = stufeCent(block, d, n > 1 ? v.betrag / n : v.betrag) * Math.min(adapter, n);
    var extras = d.__extras || [];
    var extraSumme = extras.reduce(function (s, x) { return s + x.betrag * x.stueck; }, 0);
    return { v: v, n: n, adapter: adapter, vorteil: vorteil, extras: extras, auf: v.betrag + extraSumme - vorteil };
  }

  function preisHtml(block, auf, vorteil) {
    if (!vorteil) return '<span class="hw__betrag">+' + geld(block, auf) + '</span>';
    return '<s class="vl__alt">+' + geld(block, auf + vorteil) + '</s>'
      + '<span class="hw__betrag vorteil-etikett vorteil-etikett--kontur vl__bundlepreis">+' + geld(block, auf) + '</span>';
  }

  function oneInnen(d) {
    if (!d.one_box) return '<span class="okw__text"><span class="oaw-r__t">' + esc(serieVon(d)) + '</span></span>';
    var raum = document.createElement('div');
    raum.innerHTML = d.one_box;
    var text = raum.querySelector('.okw__text');
    return text ? text.outerHTML : '';
  }

  function texte(block, d, r) {
    var name = r.n > 1 ? attr(block, 'data-vl-wort-set-n').replace('%s', serieVon(d)).replace('%d', r.n) : attr(block, 'data-vl-wort-set').replace('%s', serieVon(d));
    var unter = (r.n > 1 || r.adapter > 1) ? (r.adapter ? attr(block, 'data-vl-wort-inhalt-n').replace('%d', r.adapter) : '') : attr(block, 'data-vl-wort-inhalt');
    var extra = r.extras.map(function (x) { return '+ ' + (x.stueck > 1 ? x.stueck + '× ' : '') + x.name; }).join(' ');
    return { name: name, unter: unter, extra: extra };
  }

  function oneGruende(block, d) {
    var t = [];
    if (d.one_gruende) {
      var raum = document.createElement('div');
      raum.innerHTML = d.one_gruende;
      raum.querySelectorAll('li').forEach(function (li) { var s = (li.textContent || '').trim(); if (s) t.push(s); });
    }
    return t.length ? t : gruendeVon(block, d, true);
  }

  function kachelHtml(block, schluessel, d, istOne) {
    var r = rechnung(block, d);
    if (!r) return '';
    var kurz = serieVon(d);
    var setWort = attr(block, 'data-vl-wort-set').replace('%s', '').trim();
    return '<button type="button" class="hw__z vl-k" data-vl-wahl="' + esc(schluessel) + '"'
      + ' data-vl-id="' + r.v.id + '" data-vl-betrag="' + r.v.betrag + '" data-vl-vorteil="' + r.vorteil + '"'
      + ' data-vl-extras="' + esc(JSON.stringify(r.extras.map(function (x) { return { id: x.id, betrag: x.betrag, stueck: x.stueck }; }))) + '" aria-pressed="false">'
      + (istOne ? '<span class="beste-wahl beste-wahl--akzent hw__etikett vl-k__etikett">' + esc(attr(block, 'data-vl-wort-beliebt')) + '</span>' : '')
      + '<span class="hw__bild vl-k__bild' + (istOne ? ' hw__bild--voll' : '') + '">' + (d.bild ? '<img src="' + esc(d.bild) + '" alt="" loading="lazy">' : '') + '</span>'
      + '<span class="vl-k__set">' + esc(setWort) + '</span>'
      + '<span class="vl-k__name">' + esc(kurz) + '</span>'
      + '<span class="vl-k__preis">' + preisHtml(block, r.auf, r.vorteil) + '</span>'
      + '</button>';
  }

  function ausfuehrungHtml(block) {
    var s = block.__vlStand, opt = s.opt, d = s.d, wahl = block.__vlOneWahl;
    var offen = !!block.__vlOneOffen && opt.length > 1;
    var boxen = '';
    if (!offen) {
      boxen = opt.length > 1
        ? '<button type="button" class="oaw-r okw__r okw__r--zu" aria-current="true" aria-expanded="false" data-vl-one-auf>' + oneInnen(d[wahl])
          + '<span class="okw__aendern">' + esc(attr(block, 'data-vl-wort-aendern')) + '</span></button>'
        : '<div class="oaw-r okw__r" aria-current="true">' + oneInnen(d[wahl]) + '</div>';
    } else {
      opt.forEach(function (h) {
        var ro = rechnung(block, d[h]);
        if (!ro) return;
        var an = h === wahl;
        boxen += '<button type="button" class="oaw-r okw__r" data-vl-one-aus="' + esc(h) + '"' + (an ? ' aria-current="true"' : '') + '>'
          + oneInnen(d[h]) + '<span class="oaw-r__p' + (an ? '' : ' oaw-r__p--d') + '">+' + geld(block, ro.auf) + '</span></button>';
      });
    }
    return '<div class="okw__gruppe vl__ausf">'
      + '<div class="okw__kopf"><p class="okw__lab">' + esc(attr(block, 'data-vl-wort-ausfuehrung'))
      +   (opt.length > 1 ? '<span class="okw__zahl">' + esc(attr(block, 'data-vl-wort-zur-wahl').replace('%d', opt.length)) + '</span>' : '') + '</p>'
      +   (offen ? '<button type="button" class="okw__aktion" data-vl-one-zu>' + esc(attr(block, 'data-vl-wort-schliessen')) + '</button>' : '')
      + '</div>'
      + '<div class="okw__boxen">' + boxen + '</div>'
      + '</div>';
  }

  function feldHtml(block, schluessel, d) {
    var r = rechnung(block, d);
    if (!r) return '';
    var t = texte(block, d, r);
    var istOne = schluessel === 'one';
    var gruende = istOne ? oneGruende(block, d) : gruendeVon(block, d, false);
    return '<span class="vl__feld-kopf"><span class="hw__name">' + esc(t.name) + '</span>'
      +   (t.unter ? '<span class="hw__unter">' + esc(t.unter) + '</span>' : '')
      +   (t.extra ? '<span class="hw__unter vl__extras">' + esc(t.extra) + '</span>' : '')
      + '</span>'
      + (d.eckdaten ? '<span class="vl__eckdaten">' + d.eckdaten.replace(/<(\/?)div/g, '<$1span') + '</span>' : '')
      + (gruende.length ? '<span class="hw__gruende">' + gruende.map(function (g) { return '<span class="hw__grund">' + HAKEN + esc(g) + '</span>'; }).join('') + '</span>' : '')
      + (istOne ? ausfuehrungHtml(block) : '');
  }

  function rasterNeu(block) {
    var liste = block.querySelector('[data-vl-liste]');
    liste.querySelectorAll('[data-vl-raster], [data-vl-feld]').forEach(function (z) { z.remove(); });
    var s = block.__vlStand;
    if (!s) return;
    var html = '', zahl = 0;
    s.zeilen.forEach(function (h) {
      var k = s.d[h] ? kachelHtml(block, h, s.d[h], false) : '';
      if (k) { html += k; zahl++; }
    });
    if (s.opt.length) {
      if (!block.__vlOneWahl || s.opt.indexOf(block.__vlOneWahl) < 0) block.__vlOneWahl = s.opt[0];
      var k1 = kachelHtml(block, 'one', s.d[block.__vlOneWahl], true);
      if (k1) { html += k1; zahl++; }
    }
    if (!zahl) return;
    liste.insertAdjacentHTML('beforeend', '<div class="vl__raster" data-vl-raster style="--vl-sp:' + zahl + '">' + html + '</div>'
      + '<div class="vl__feld" data-vl-feld hidden></div>');
  }

  function feldSetzen(block) {
    var feld = block.querySelector('[data-vl-feld]');
    if (!feld) return;
    var kacheln = Array.prototype.slice.call(block.querySelectorAll('[data-vl-raster] > [data-vl-wahl]'));
    var z = kacheln.filter(function (k) { return k.classList.contains('hw__z--an'); })[0];
    var s = block.__vlStand;
    if (!z || !s) { feld.hidden = true; feld.innerHTML = ''; return; }
    var schluessel = z.getAttribute('data-vl-wahl');
    var d = s.d[schluessel === 'one' ? block.__vlOneWahl : schluessel];
    feld.innerHTML = d ? feldHtml(block, schluessel, d) : '';
    var i = kacheln.indexOf(z), n = kacheln.length;
    feld.style.setProperty('--vl-spitze', 'calc((100% - ' + ((n - 1) * 8) + 'px) / ' + n + ' * ' + (i + 0.5) + ' + ' + (i * 8) + 'px)');
    feld.hidden = !feld.innerHTML;
  }

  function oneNeu(block) {
    if (!block.__vlStand) return;
    rasterNeu(block);
    waehlen(block, block.querySelector('[data-vl-wahl="one"]'));
  }

  function markeSetzen(block, geprueft) {
    var m = block.querySelector('[data-vl-marke]');
    if (!m) return;
    m.innerHTML = geprueft
      ? '<span class="fck__vf fck__vf--satz"><span class="fck__vf-punkt" aria-hidden="true"></span>3IDEE VERIFIED'
        + '<button class="fck__vf-i" type="button" data-fenster-auf="verified" aria-label="' + esc(attr(block, 'data-vl-wort-verified-aria')) + '">i</button></span>'
      : '<span class="vl__ungeprueft">' + esc(attr(block, 'data-vl-wort-ungeprueft')) + '</span>';
  }

  function aufbauen(block) {
    var l = lage(block);
    var el = engineLage();
    var kennung = l.refs.join(',') + '|' + l.geprueft + '|' + l.kennung + '|' + el.wand + '|' + el.dicke + '|' + el.art + '|' + bolzenKennung(block);
    if (block.__vlKennung === kennung) return;
    block.__vlKennung = kennung;
    block.__vlLage = l;
    markeSetzen(block, l.geprueft);
    nurSetzen(block, null);
    adapterPostenLaden(block, l).then(function (p) {
      if (block.__vlKennung !== kennung) return;
      nurSetzen(block, p);
      kaufboxSetzen(block);
    });

    var weg;
    if (l.refs.length && !l.einzeln) {
      weg = engine(block, l.refs).then(function (a) { return zeilenWaehlen(block, [a], l.n); });
    } else if (l.refs.length) {
      weg = Promise.all(l.refs.map(function (r) { return engine(block, r); })).then(function (a) { return zeilenWaehlen(block, a, 1); });
    } else {
      var ersatz = (block.getAttribute('data-vl-ersatz') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var oneE = block.getAttribute('data-vl-one');
      weg = Promise.resolve({ zeilen: ersatz, oneOptionen: oneE ? [oneE] : [] });
    }
    weg.then(function (w) {
      if (block.__vlKennung !== kennung) return;
      if (!w) { zeichnen(block, [], [], {}); return; }
      var alle = w.zeilen.concat(w.oneOptionen || []);
      var ein = w.eintraege || {};
      return Promise.all([
        Promise.all(alle.map(produkt)),
        Promise.all(alle.map(function (h) { return pflichtteile(block, ein[h]); }))
      ]).then(function (r) {
        if (block.__vlKennung !== kennung) return;
        var d = {};
        alle.forEach(function (h, i) { if (r[0][i]) { d[h] = Object.assign({}, r[0][i], { __extras: r[1][i] || [] }); } });
        var preis = function (h) { var v = d[h] && (d[h].varianten || []).filter(function (x) { return x.kaufbar; })[0]; return v ? v.betrag : Infinity; };
        var opt = (w.oneOptionen || []).filter(function (h) { return preis(h) < Infinity; })
          .sort(function (x, y) { return preis(x) - preis(y); });
        zeichnen(block, w.zeilen, opt, d);
      });
    });
  }

  function seitenAdapter(block) {
    var d = adapterDaten(block);
    var feld = kaufform() && kaufform().querySelector('input[name="id"]');
    var id = feld ? Number(feld.value) : 0;
    var v = (d.varianten || []).filter(function (x) { return x.id === id; })[0];
    return v || (d.varianten || [])[0] || null;
  }

  function adapterPostenLaden(block, l) {
    var sa = seitenAdapter(block);
    if ((l.eigen || 0) === 1 && !(l.fremd || []).length) return Promise.resolve(null);
    var posten = [];
    if (l.eigen && sa) posten.push({ id: sa.id, betrag: sa.betrag, stueck: l.eigen, bild: '' });
    return Promise.all((l.fremd || []).map(function (m) {
      return produkt(m.alt).then(function (d) {
        var v = d && (d.varianten || []).filter(function (x) { return x.kaufbar; })[0];
        return v ? { id: v.id, betrag: v.betrag, stueck: m.anzahl, bild: d.bild || '', fuer: m.name } : null;
      });
    })).then(function (a) {
      var gleich = {};
      posten.concat(a.filter(Boolean)).forEach(function (p) {
        if (gleich[p.id]) gleich[p.id].stueck += p.stueck; else gleich[p.id] = p;
      });
      var raus = Object.keys(gleich).map(function (k) { return gleich[k]; });
      return raus.length ? raus : null;
    });
  }

  function nurSetzen(block, posten) {
    block.__vlPosten = posten;
    var unter = block.querySelector('[data-vl-nur-unter]');
    var preis = block.querySelector('[data-vl-nur-preis]');
    var bild = block.querySelector('[data-vl-nur-bild]');
    if (preis && !preis.hasAttribute('data-vl-ur')) preis.setAttribute('data-vl-ur', preis.innerHTML);
    if (bild && !bild.hasAttribute('data-vl-ur')) bild.setAttribute('data-vl-ur', bild.innerHTML);
    if (!posten) {
      if (unter) { unter.hidden = true; unter.textContent = ''; }
      if (preis && preis.hasAttribute('data-vl-ur')) preis.innerHTML = preis.getAttribute('data-vl-ur');
      if (bild && bild.hasAttribute('data-vl-ur')) bild.innerHTML = bild.getAttribute('data-vl-ur');
      return;
    }
    var stueck = posten.reduce(function (s, p) { return s + p.stueck; }, 0);
    var summe = posten.reduce(function (s, p) { return s + p.betrag * p.stueck; }, 0);
    var text = '';
    if (stueck === 1 && posten[0].fuer) text = attr(block, 'data-vl-wort-passend').replace('%s', posten[0].fuer);
    else if (stueck > 1) text = attr(block, 'data-vl-wort-nur-n').replace('%d', stueck);
    if (unter) { unter.textContent = text; unter.hidden = !text; }
    if (preis) preis.textContent = geld(block, summe);
    var fremdBild = posten.filter(function (p) { return p.bild; })[0];
    if (bild && fremdBild && posten.length === 1) bild.innerHTML = '<img src="' + esc(fremdBild.bild) + '" alt="" loading="lazy">';
    else if (bild && bild.hasAttribute('data-vl-ur')) bild.innerHTML = bild.getAttribute('data-vl-ur');
  }

  function zeichnen(block, zeilen, opt, d) {
    var liste = block.querySelector('[data-vl-liste]');
    block.__vlStand = { zeilen: zeilen || [], opt: opt || [], d: d || {} };
    block.__vlOneOffen = false;
    rasterNeu(block);
    var vorher = block.__vlWahl;
    var erste = liste.querySelector('[data-vl-wahl]:not([data-vl-wahl="nur"])');
    var ziel = (vorher && liste.querySelector('[data-vl-wahl="' + vorher + '"]')) || erste || liste.querySelector('[data-vl-wahl="nur"]');
    if (!block.__vlVonHand) ziel = erste || liste.querySelector('[data-vl-wahl="nur"]');
    waehlen(block, ziel);
  }

  function kaufform() {
    var alle = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < alle.length; i++) { if (!alle[i].closest('dialog')) return alle[i]; }
    return null;
  }
  function kaufknopf() { var f = kaufform(); return f ? f.querySelector('button[type="submit"]') : null; }
  function knopfZiel(knopf) {
    var ziel = null;
    knopf.querySelectorAll('span').forEach(function (sp) { if (!ziel && sp.children.length === 0 && (sp.textContent || '').trim()) ziel = sp; });
    return ziel;
  }
  function knopfUrtext(knopf) {
    var da = knopf.getAttribute('data-vl-urtext');
    if (da) return da;
    var z = knopfZiel(knopf);
    var t = z ? (z.textContent || '').trim() : (knopf.textContent || '').trim();
    if (t) knopf.setAttribute('data-vl-urtext', t);
    return t;
  }
  function knopfText(knopf, text) { var z = knopfZiel(knopf); if (z) z.textContent = text; else knopf.textContent = text; }
  function adapterPosten(block) {
    if (block.__vlPosten) return block.__vlPosten;
    var sa = seitenAdapter(block);
    return sa ? [{ id: sa.id, betrag: sa.betrag, stueck: 1 }] : [];
  }
  function preisTraeger(block) {
    var raus = [];
    var kn = kaufknopf();
    var spalte = block.closest('.product-details, product-details, [class*="product-details"]') || document;
    spalte.querySelectorAll('[ref="priceContainer"]').forEach(function (t) { if (raus.indexOf(t) < 0 && !t.closest('dialog')) raus.push(t); });
    document.querySelectorAll('.sticky-add-to-cart [ref="priceContainer"], sticky-add-to-cart [ref="priceContainer"]')
      .forEach(function (t) { if (raus.indexOf(t) < 0) raus.push(t); });
    return raus;
  }
  function mengenTraeger() {
    var f = kaufform();
    var mf = f && f.querySelector('input[name="quantity"]');
    return mf ? mf.closest('quantity-selector-component, .quantity-selector, [class*="quantity"]') : null;
  }

  function waehlen(block, zeile) {
    if (!zeile) return;
    block.querySelectorAll('[data-vl-wahl]').forEach(function (z) {
      var an = z === zeile;
      z.classList.toggle('hw__z--an', an);
      z.setAttribute('aria-pressed', an ? 'true' : 'false');
    });
    block.__vlWahl = zeile.getAttribute('data-vl-wahl');
    feldSetzen(block);
    kaufboxSetzen(block);
  }

  function gewaehlt(block) {
    var z = block.querySelector('[data-vl-wahl].hw__z--an');
    if (!z || z.getAttribute('data-vl-wahl') === 'nur') return null;
    var extras = [];
    try { extras = JSON.parse(z.getAttribute('data-vl-extras') || '[]') || []; } catch (e) { extras = []; }
    var extraSumme = extras.reduce(function (s, x) { return s + x.betrag * x.stueck; }, 0);
    return { id: Number(z.getAttribute('data-vl-id')), betrag: Number(z.getAttribute('data-vl-betrag')) + extraSumme,
             vorteil: Number(z.getAttribute('data-vl-vorteil')) || 0, extras: extras };
  }

  function kaufboxSetzen(block) {
    var h = gewaehlt(block);
    var ap = adapterPosten(block);
    var av = ap.length ? { betrag: ap.reduce(function (s, p) { return s + p.betrag * p.stueck; }, 0) } : null;
    var knopf = kaufknopf();
    var mt = mengenTraeger();
    if (mt) mt.classList.toggle('vl--weg', !!h || !!block.__vlPosten);
    preisTraeger(block).forEach(function (t) {
      var eigen = t.querySelector(':scope > .vl__gesamt');
      if (!eigen) { eigen = document.createElement('div'); eigen.className = 'vl__gesamt'; eigen.hidden = true; t.appendChild(eigen); }
      if (!av || (!h && !block.__vlPosten)) { eigen.hidden = true; t.classList.remove('vl--eigenpreis'); return; }
      var vorteil = h ? h.vorteil : 0;
      var voll = av.betrag + (h ? h.betrag : 0), summe = voll - vorteil;
      var spar = attr(block, 'data-vl-wort-sparst').replace('%s', geld(block, vorteil));
      eigen.innerHTML = (vorteil ? '<s class="vl__gesamt-alt">' + geld(block, voll) + '</s>' : '')
        + '<span class="price">' + geld(block, summe) + '</span>'
        + (vorteil ? '<span class="vorteil-etikett vorteil-etikett--sparst">' + esc(spar) + '</span>' : '');
      eigen.hidden = false;
      t.classList.add('vl--eigenpreis');
    });

    document.dispatchEvent(new CustomEvent('3idee:auswahlpreis', { detail: { cent: av && (h || block.__vlPosten) ? av.betrag + (h ? h.betrag - h.vorteil : 0) : 0 } }));
    if (!knopf) return;
    var ur = knopfUrtext(knopf);
    knopfText(knopf, h ? attr(block, 'data-vl-wort-korb') : ur);
  }

  function selbstLegen(block) { return !!(gewaehlt(block) || block.__vlPosten); }

  function legen(block) {
    var h = gewaehlt(block), ap = adapterPosten(block), knopf = kaufknopf();
    if (!ap.length || !window.WarenkorbLegen || !(h || block.__vlPosten)) return false;
    if (knopf) knopf.disabled = true;
    var alt = knopf && knopf.parentNode && knopf.parentNode.querySelector('.vl__fehler');
    if (alt) alt.remove();
    var posten = ap.map(function (p) { return { id: p.id, quantity: p.stueck }; });
    if (h) {
      posten.push({ id: h.id, quantity: 1 });
      h.extras.forEach(function (x) { posten.push({ id: x.id, quantity: x.stueck }); });
    }
    window.WarenkorbLegen(posten, function (ok, grund) {
      if (knopf) knopf.disabled = false;
      if (ok || !knopf) return;
      var zeile = document.createElement('p');
      zeile.className = 'vl__fehler';
      zeile.setAttribute('role', 'alert');
      zeile.textContent = grund || attr(block, 'data-vl-wort-fehler');
      knopf.insertAdjacentElement('afterend', zeile);
    });
    return true;
  }

  function abfangen(block) {
    if (window.__vlAbgefangen) return;
    window.__vlAbgefangen = true;
    document.addEventListener('click', function (e) {
      var knopf = e.target.closest && e.target.closest('button[type="submit"]');
      if (!knopf || !kaufform() || knopf.closest('form') !== kaufform()) return;
      if (!selbstLegen(block)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      legen(block);
    }, true);
    var f = kaufform();
    if (f) {
      (f.closest('product-form-component') || f).addEventListener('submit', function (e) {
        if (!selbstLegen(block)) return;
        e.preventDefault();
        e.stopPropagation();
        legen(block);
      }, true);
    }
  }

  function start() {
    document.querySelectorAll('[data-vl]').forEach(function (block) {
      if (!block.__vlStart) {
        block.__vlStart = true;
        block.addEventListener('click', function (e) {
          if (e.target.closest('.fck__vf-i')) return;
          var z = e.target.closest('[data-vl-wahl]');
          var auf = e.target.closest('[data-vl-one-auf]'), aus = e.target.closest('[data-vl-one-aus]'), zu = e.target.closest('[data-vl-one-zu]');
          if (auf || aus || zu) {
            block.__vlVonHand = true;
            if (auf) block.__vlOneOffen = true;
            if (aus) { block.__vlOneWahl = aus.getAttribute('data-vl-one-aus'); block.__vlOneOffen = false; }
            if (zu) block.__vlOneOffen = false;
            block.__vlWahl = 'one';
            oneNeu(block);
            var fokus = block.querySelector(block.__vlOneOffen ? '[data-vl-one-aus][aria-current]' : '[data-vl-one-auf]');
            if (fokus) fokus.focus();
            return;
          }
          if (!z) return;
          block.__vlVonHand = true;
          waehlen(block, z);
        });
        abfangen(block);
      }
      aufbauen(block);
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('finder:auswahl', function () {
    document.querySelectorAll('[data-vl]').forEach(function (b) { b.__vlVonHand = false; });
    start();
  });
  document.addEventListener('3idee:passung', function (e) {
    var d = (e && e.detail) || {};
    var ms = d.monitore || [];
    var ok = ms.length ? ms.some(function (m) { return m && m.stufe !== 'warn'; }) : d.stufe !== 'warn';
    document.querySelectorAll('[data-vl]').forEach(function (b) {
      b.__vlPassung = ok ? 'ok' : 'warn';
      b.__vlMonitore = ms.slice();
      aufbauen(b);
    });
  });
  document.addEventListener('engine:status', start);
  document.addEventListener('variant:update', function () {
    document.querySelectorAll('[data-vl]').forEach(kaufboxSetzen);
  });
})();

